import { render } from "./PasswordCriteria.vue?vue&type=template&id=5cf01a29"
import script from "./PasswordCriteria.vue?vue&type=script&lang=js"
export * from "./PasswordCriteria.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__